import { render, staticRenderFns } from "./white-space.vue?vue&type=template&id=21fac835&scoped=true"
import script from "./white-space.vue?vue&type=script&lang=js"
export * from "./white-space.vue?vue&type=script&lang=js"
import style0 from "./white-space.vue?vue&type=style&index=0&id=21fac835&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fac835",
  null
  
)

export default component.exports